/* jshint esversion: 6 */
/* jshint esversion: 8 */
/* jshint esversion: 11 */
/* jshint ignore:start */
import { useContext, useEffect, useState } from "react";
import { MyContext } from "../../Context/MyProvider";
import { socket } from "../../socket";
import { useTranslation } from "react-i18next";
import secureLocalStorage from "react-secure-storage";
import axios from "axios";

// Import provider views
import AgoraCallView from "./AgoraCallView";
import WebRTCCallView from "./WebRTCCallView";
import TwilioCallView from "./TwilioCallView";
import MiroTalkCallView from "./MiroTalkCallView";
import JanusCallView from "./JanusCallView";
import HMSCallView from "./HMSCallView";

const VideoCall = ({ Data }) => {
  const { t } = useTranslation();

  const {
    ImgBaseUrl,
    setAgoraAppId,
    videoCallProvider,
    setShowCall,
    ApiBaseUrl,
  } = useContext(MyContext);

  const [calling, setCalling] = useState(false);
  const [channel, setChannel] = useState("");
  const [token, setToken] = useState(null);
  const [micOn, setMic] = useState(false);
  const [cameraOn, setCamera] = useState(false);

  const [userId, setUserId] = useState(() =>
    secureLocalStorage.getItem("Userid"),
  );

  const HandleCallAnswer = async () => {
    const Userid = secureLocalStorage.getItem("Userid");

    if (Userid) {
      setUserId(Userid);
      setMic(true);
      setCamera(true);

      socket.emit("Audio_video_call_Answer", {
        id: String(Data?.doctor_id),
        uid: String(Userid),
      });

      if (videoCallProvider === "agora") {
        const channelName = `${Userid}_${Data?.doctor_id}`;
        setChannel(channelName);
        try {
          
          console.log("Body", {
            channel_name: `${Userid}_${Data?.call_id}`,
            uid: Number(Userid) || 0,
          });

          const response = await axios.post(
            `${ApiBaseUrl}/customer/get_token`,
            {
              channel_name: `${Userid}_${Data?.call_id}`,
              uid: Number(Userid) || 0,
            },
          );

          console.log("response", response);

          if (response.data && response.data.token) {
            setToken(response.data.token);
            if (response.data.app_id) {
              setAgoraAppId(response.data.app_id);
            }
          }
        } catch (error) {
          console.error("Agora token fetch failed:", error);
        }
      }

      setCalling(true);
    }
  };

  const LeaveCall = () => {
    const Userid = secureLocalStorage.getItem("Userid");
    if (Userid) {
      const SocketData = {
        uid: String(Data?.doctor_id),
        id: String(Userid),
      };
      socket.emit("Audio_video_call_Cut", SocketData);
    }

    setCalling(false);
    setMic(false);
    setCamera(false);
    setShowCall(false);
  };

  useEffect(() => {
    const Userid = secureLocalStorage.getItem("Userid");

    const handleNewChat = (msg) => {
      LeaveCall();
    };

    socket.on(`Other_user_Call_Cut ${Userid}`, handleNewChat);
    socket.on("dismiss_incoming_call", handleNewChat);
    socket.on("call_accepted_elsewhere", handleNewChat);

    return () => {
      socket.off(`Other_user_Call_Cut ${Userid}`, handleNewChat);
      socket.off("dismiss_incoming_call", handleNewChat);
      socket.off("call_accepted_elsewhere", handleNewChat);
    };
  }, []);

  const renderCallView = () => {
    switch (videoCallProvider) {
      case "agora":
        return (
          <AgoraCallView
            Data={Data}
            channel={channel}
            token={token}
            micOn={micOn}
            setMic={setMic}
            cameraOn={cameraOn}
            setCamera={setCamera}
            LeaveCall={LeaveCall}
            calling={calling}
          />
        );
      case "webrtc":
        return (
          <WebRTCCallView
            Data={Data}
            LeaveCall={LeaveCall}
            userId={userId}
            micOn={micOn}
            setMic={setMic}
            cameraOn={cameraOn}
            setCamera={setCamera}
          />
        );
      case "mirotalk":
        return (
          <MiroTalkCallView Data={Data} LeaveCall={LeaveCall} userId={userId} />
        );
      case "twilio":
        return (
          <TwilioCallView
            Data={Data}
            LeaveCall={LeaveCall}
            userId={userId}
            micOn={micOn}
            setMic={setMic}
            cameraOn={cameraOn}
            setCamera={setCamera}
          />
        );
      case "janus":
        return (
          <JanusCallView
            Data={Data}
            LeaveCall={LeaveCall}
            userId={userId}
            micOn={micOn}
            setMic={setMic}
            cameraOn={cameraOn}
            setCamera={setCamera}
          />
        );
      case "100ms":
        return (
          <HMSCallView
            Data={Data}
            LeaveCall={LeaveCall}
            userId={userId}
            micOn={micOn}
            setMic={setMic}
            cameraOn={cameraOn}
            setCamera={setCamera}
          />
        );
      default:
        return (
          <WebRTCCallView
            Data={Data}
            LeaveCall={LeaveCall}
            userId={userId}
            micOn={micOn}
            setMic={setMic}
            cameraOn={cameraOn}
            setCamera={setCamera}
          />
        );
    }
  };

  return (
    <div className="w-full h-full">
      {calling ? (
        renderCallView()
      ) : (
        <div
          style={{ backgroundImage: `url(${ImgBaseUrl + Data?.logo})` }}
          className="bg_img audio_box !w-full !h-full"
        >
          <div className="h-[100%] flex items-end justify-center z-[888] relative px-[10px] py-[20px]">
            <div className="text-center">
              <h1 className="text-white font-[500] text-[18px]">
                {Data?.name}
              </h1>
              <span className="text-white text-[16px]">
                ({t("In Coming Video Call From")}) {Data?.name}
              </span>
              <div className="mt-[25px] flex items-center justify-center gap-[50px]">
                <button
                  onClick={LeaveCall}
                  className="bg-red-500 p-[10px] rounded-[50px] transition-transform hover:scale-110 active:scale-95 shadow-lg"
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="white"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g id=" 24px / Call Missed">
                      <g id="Call Missed">
                        <path
                          id="Stroke 1"
                          d="M21.3283 2.75L15.3283 8.75"
                          stroke="white"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          id="Stroke 3"
                          d="M15.3283 2.75L21.3283 8.75"
                          stroke="white"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          id="Stroke 5"
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M7.70098 16.299C0.802193 9.40023 1.78303 6.24116 2.51123 5.22211C2.60358 5.05863 4.90601 1.61189 7.3751 3.63408C13.5011 8.67946 5.74461 7.96612 10.8898 13.1113C16.0339 18.2554 15.3205 10.5 20.3659 16.6249C22.3881 19.094 18.9414 21.3954 18.7779 21.4888C17.7588 22.217 14.5998 23.1978 7.70098 16.299Z"
                          stroke="white"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </g>
                    </g>
                  </svg>
                </button>
                <button
                  onClick={HandleCallAnswer}
                  className="bg-green-500 p-[10px] rounded-[50px] transition-transform hover:scale-110 active:scale-95 shadow-lg"
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g id=" 24px / Call">
                      <g id="Call">
                        <path
                          id="Stroke 1"
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M8.20049 15.799C1.3025 8.90022 2.28338 5.74115 3.01055 4.72316C3.10396 4.55862 5.40647 1.11188 7.87459 3.13407C14.0008 8.17945 6.2451 7.46611 11.3894 12.6113C16.5348 17.7554 15.8214 9.99995 20.8659 16.1249C22.8882 18.594 19.4413 20.8964 19.2778 20.9888C18.2598 21.717 15.0995 22.6978 8.20049 15.799Z"
                          stroke="white"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </g>
                    </g>
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default VideoCall;
/* jshint ignore:end */
